<template>
  <!-- <b-modal
    :id="'change-pass-modal' + rowId"
    size="md"
    :title='$t("user.change_password_window.title")'
    title-class="font-18"
    no-close-on-esc
    no-close-on-backdrop
    ref="change_password"
    centered
    :ok-title='$t("user.change_password_window.ok_button")'
    :cancel-title='$t("user.change_password_window.cancel_button")'
    @show="resetModal"
    @hidden="resetModal"
    @ok="onChangePassword"
  > -->
    <form ref="change-pass-form">
      <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if='modalErrorMessage'>
        {{ modalErrorMessage }}
      </div>

      <TextField 
        v-if="user.role.role != 'administration'"
        :placeholder='$t("user.change_password_window.old_password.placeholder")'
        :label='$t("user.change_password_window.old_password.label")'
        icon="lock"
        name="old_password"
        type="password"
        :value="model.old_password"
        v-model="model.old_password"
      />

      <TextField 
        :placeholder='$t("user.change_password_window.new_password.placeholder")'
        :label='$t("user.change_password_window.new_password.label")'
        icon="lock"
        name="new_password"
        type="password"
        :value="model.new_password"
        :error="$v.model.new_password.$error"
        :errorMessage="$v.model.new_password.errorMessage"
        v-model="model.new_password"
      />

      <TextField 
        :placeholder='$t("user.change_password_window.confirm_password.placeholder")'
        :label='$t("user.change_password_window.confirm_password.placeholder")'
        icon="lock"
        name="confirm_password"
        type="password"
        :value="model.confirm_password"
        :error="$v.model.confirm_password.$error"
        :errorMessage="$v.model.confirm_password.errorMessage"
        v-model="model.confirm_password"
      />
    </form>
  <!-- </b-modal> -->
</template>

<script>
import TextField from '@components/form/textfield.vue'
import FormMixins from '@mixins/form'
import { required } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'

export default {
  mixins: [ FormMixins ],
  components: {
    TextField
  },
  props: {
    rowId: String
  },
  validations: {
    model:{
      new_password: { required },
      confirm_password: { required },
    }
  },
  data () {
    return {
      modalErrorMessage: '',
      model: {
        new_password: "",
        confirm_password: ""
      }
    }
  },
  methods: {
		...mapActions('user', ['pagination', 'activate', 'changePassword']),
    show () {
      this.$refs.change_password.show()
    },
    hide () {
      this.$refs.change_password.hide()
    },
    resetModal(){
      this.change_pass.old_password = ''  
      this.change_pass.new_password = ''
      this.change_pass.confirm_password = ''
    },
    // onChangePassword(event) {
    //   event.preventDefault()

    //   this.change_pass.id = this.rowId
    //   this.modalErrorMessage = ''

    //   this.changePassword(this.change_pass).then(res => {
    //     if(res.data.success){
    //       // Trigger submit handler
    //       this.$nextTick(() => {
    //         this.hide()
    //       })

    //       /* this.$bvModal.msgBoxOk('Password is now changed!',{
    //         title: 'Notification'
    //       }) */

    //       this.resetModal()

    //       this.$bvToast.toast(`Password is now changed!`, {
    //         title: 'Notification',
    //         variant:'success'
    //       })

    //     }else{
    //       this.modalErrorMessage = res.data.errorMessage
    //     }

    //   })
    // },
  }
}
</script>